import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";
import OutlinedContainer from "./FormFields/Container/OutlinedContainer";
import { Box } from "@mui/material";

type OutlinedFieldDisplayProps = {
  field: string;
  value: any;
};
export default function OutlinedFieldDisplay({
  field,
  value,
}: OutlinedFieldDisplayProps) {
  const { t } = useTranslation();
  if (typeof value === "boolean") {
    const color = value ? "green" : "red"; 
    const keyword = value ? "yes" : "no"; 
    const iconStyle = {
      height: "22px",
      color: color,
    };

    value = <Box sx={iconStyle}>{t(`KEYWORD.${keyword}`)}</Box>
  }

  return (
    <OutlinedContainer height="fit-content" addLabel={false}>
      <Box
        sx={{
          paddingBottom: 1,
          display: "flex",
          gap: 2,
        }}
      >
        <span style={{ fontWeight: "bold", alignSelf: "start" }}>
          {t(`FORM.FIELD.${field}`)}:
        </span>
        <span
          style={{
            alignSelf: "center",
            flexGrow: 1,
            textAlign: "end",
            paddingRight: 5,
          }}
        >
          {value}
        </span>
      </Box>
    </OutlinedContainer>
  );
}
